import { useMapEvents } from "react-leaflet";
import PropTypes from "prop-types";

const AddBranchMarker = ({ onAddBranch }) => {
  useMapEvents({
    dblclick: (e) => {
      const { lat, lng } = e.latlng;
      onAddBranch({ latitude: lat, longitude: lng });
    },
  });

  return null;
};

AddBranchMarker.propTypes = {
  onAddBranch: PropTypes.func.isRequired,
};

export default AddBranchMarker;
